/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Dropbox_Ingest_SuccessInputs */

const es_tools_dropbox_ingest_success = /** @type {(inputs: Tools_Dropbox_Ingest_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos de Dropbox ingestados`)
};

const en_tools_dropbox_ingest_success = /** @type {(inputs: Tools_Dropbox_Ingest_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropbox files ingested`)
};

/**
* | output |
* | --- |
* | "Dropbox files ingested" |
*
* @param {Tools_Dropbox_Ingest_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_dropbox_ingest_success = /** @type {((inputs?: Tools_Dropbox_Ingest_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Dropbox_Ingest_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_dropbox_ingest_success(inputs)
	return en_tools_dropbox_ingest_success(inputs)
});
export { tools_dropbox_ingest_success as "tools.dropbox.ingest_success" }